import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from '../assets/img/Leetcode2.svg';

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            {/* <img src={logo} alt="Logo" /> */}
            <h1 className="logo" style={{ color: 'white', fontWeight: '800' }}>AJAY</h1>

          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/dev-ajayp/"><img src={navIcon1} alt="" /></a>
              <a href="https://leetcode.com/u/AjayPrajapati/"><img src={navIcon4} alt="" /></a>
            </div>
            <p>Copyright {new Date().getFullYear()}. All Rights Reserved. Built with ❤️ by Ajay Prajapati</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
